import { schoolTokenAxios } from "../axios";
const REPORTING_BASE = process.env.REACT_APP_SCHOOL_REPORTING_BASE;

let library = `${REPORTING_BASE}/library`;

export const getAllLibraryBooks = (params) => {
  return schoolTokenAxios.get(`${library}/getAllLibraryBooks`, {
    params: params,
  });
};

export const getLibraryBookSummary = (params) => {
  return schoolTokenAxios.get(`${library}/getLibraryBookSummary`, {
    params: params,
  });
};

export const addLibraryBook = (payload) => {
  return schoolTokenAxios.post(`${library}/addLibraryBook`, payload);
};

export const updateLibraryBook = (body) => {
  return schoolTokenAxios.put(`${library}/updateLibraryBook`, body);
};

export const deleteLibraryBook = (deleteDocId) => {
  return schoolTokenAxios.delete(`${library}/deleteLibraryBook/${deleteDocId}`);
};

export const issueBookToUser = (body) => {
  return schoolTokenAxios.post(`${library}/issueBookToUser`, body);
};

export const getBookTransaction = (params) => {
  return schoolTokenAxios.get(`${library}/getBookTransaction`, {
    params: params,
  });
};

export const getLibraryBookByName = (params) => {
  // params: { session, bookName }
  return schoolTokenAxios.get(`${library}/getLibraryBookByName`, { params });
};

export const getAllLibraryDistinctValues = (params) => {
  return schoolTokenAxios.get(`${library}/getAllLibraryDistinctValues`, {
    params: params,
  });
};

export const changeStatusOfIssuedBook = (body) => {
  return schoolTokenAxios.put(`${library}/changeStatusOfIssuedBook`, body);
};
